var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clients-access-list"},[_c('ClientsAccessHeaders',{attrs:{"cliets-access-type":_vm.clietsAccessType}}),_vm._l((_vm.accessClientsData),function(client){return _c('ClientsAccessElement',{key:client.id,attrs:{"cliets-access-type":_vm.clietsAccessType,"client":client}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }